<template>
  <div>
    <v-row v-if="activeType === 'voucher'">
      <v-col cols="12" sm="6">
        <text-field
          v-model.number="config.settings.quantity_in_period"
          :label="$t('how_many_vouchers_daily')"
          type="number"
          outlined
          dense
          :hint="$t('number_of_vouchers_available_daily')"
          persistent-hint
        />
      </v-col>
    </v-row>
    <v-row v-if="activeType === 'order'">
      <v-col v-if="config.settings.limit_by_quantity" cols="12" sm="6">
        <text-field
          v-model.number="config.settings.max_orders"
          :label="$t('how_many_orders_daily')"
          type="number"
          outlined
          dense
          :hint="$t('max_orders_hint')"
          persistent-hint
        />
      </v-col>
      <v-col v-if="config.settings.limit_by_value" cols="12" sm="6">
        <text-field
          v-model.number="config.settings.max_order_value"
          :label="$t('max_order_value')"
          type="number"
          suffix="KM"
          outlined
          dense
          :hint="$t('max_order_value_hint')"
          persistent-hint
        />
      </v-col>
    </v-row>
    <v-row v-if="activeType === 'credit'">
      <v-col cols="12" sm="6">
        <text-field
          v-model.number="config.settings.max_amount"
          :label="$t('credit_amount_daily')"
          type="number"
          suffix="KM"
          outlined
          dense
          :hint="$t('credit_amount_renews_daily')"
          persistent-hint
        />
      </v-col>
    </v-row>
    <v-row v-if="activeType === 'money'">
      <v-col cols="12" sm="6">
        <text-field
          v-model.number="config.settings.limit_amount"
          :label="$t('money_limit_amount_daily')"
          type="number"
          suffix="KM"
          outlined
          dense
          :hint="$t('money_limit_amount_daily_hint')"
          persistent-hint
        />
      </v-col>
    </v-row>
    <v-alert
      v-else-if="
        activeType !== 'voucher' &&
        activeType !== 'order' &&
        activeType !== 'credit' &&
        activeType !== 'money'
      "
      type="info"
      text
      dense
      class="mb-3"
    >
      <div class="font-weight-medium mb-1">Dnevni limit trenutno nije dostupan</div>
      <div class="text-caption">
        Nedostupna polja: Vreme resetovanja limita, poseban limit za vikend
      </div>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "DailyLimitFields",
  props: {
    config: {
      type: Object,
      required: true,
    },
    activeType: {
      type: String,
      required: true,
    },
  },
};
</script>
